import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/accounting/area/filter'; // Importing Filter component
import Table from 'views/accounting/area/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Represents the area view component.
 * @extends JetView
 */
export default class areaView extends JetView {
    /**
     * Configures the layout of the area view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Screen size configuration

        const right = {
            type: 'wide',
            rows: [],
        };

        /**
         * Toolbar configuration with pagination and export options.
         * @type {Object}
         */
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Areas'),
                                    ignore: { rating: true }, // Ignore rating column during export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Areas'),
                                        autowidth: true, // Automatically adjust width
                                        ignore: { rating: true }, // Ignore rating column during export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        /**
         * Left panel configuration with toolbar and table.
         * @type {Object}
         */
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for actions
                    css: theme,
                    elements: [
                        { id: 'grav' },
                        {
                            cols: [
                                {
                                    view: 'button', // Button to add area
                                    value: _('Añadir Área'),
                                    type: 'form',
                                    width: screen == 'small' ? 0 : 200,
                                    minWidth: 250,
                                    hidden: !devConfig.getPermAction(
                                        'accountingAreaAdd',
                                        'Add', // Check permission for adding area
                                    ),
                                    css: 'prm-accountingAreaAdd',
                                    click: () => {
                                        // Click event to add area
                                        this.app.callEvent('addArea:button', [{}]);
                                    },
                                },
                            ],
                        },
                    ],
                },
                Table, // Reference to the Table component
                toolbar, // Reference to the toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left panel
                },
            ],
        };
    }

    /**
     * Initializes the area view.
     */
    init() {
        if (screen.width < 500) {
            // Check screen width for responsive design
            $$('grav').hide(); // Hide element if screen is small
        }
    }
}

// FILE DOCUMENTED
